import React from 'react';

const FooterPages = () => (
    <div className="grid grid-cols-1 gap-4" >
        <div className="flex flex-col">
            <p className="dark:text-gray-200 text-gray-700 text-center text-xs m-20">
            © 2025 Todos los derechos reservados por Biomap Spa
            </p>
        </div>
    </div>   
);

export default FooterPages;